<!-- A popup dialog to select a different brand -->
<app-choose-brand [displayBrandDialog] = "openBrandSelectionDialog" (chooseBrandEvent)="chooseBrand($event)"></app-choose-brand>

<!--- Generic header, inclusing current brand and a button to select another brand -->

<div class="grid">
    <div class="col-7">
        <p-message severity="info" text="{{titleMessage}}"></p-message>
    </div>
   <div class="col-1">
       <button pButton type="button" label="Brand" icon="pi pi-sitemap" iconPos="left" (click)="onChooseBrandClick($event)"  
            class="p-button-raised p-button-rounded">
        </button>
   </div>  
</div> 

<div class="col-5">

    <p-card header="Customer Account" subheader="" styleClass="ui-card-light" >

        <div class="grid">   
            
            <div class="col-6">

                <div class="field grid">
                    <div class="col-1"></div>
                        <label for="extAccountId" class="col-fixed label" style="width: 9em">Account Id:</label>
                    <div class="col-2">
                        <input pInputText id="extAccountId" type="text" [(ngModel)]="extAccountId" 
                        pTooltip="Unique customer's account identifier within the brand" tooltipPosition="top"/> 
                    </div>
                </div>
    
            </div>

            <div class="col-2"></div>
            <div class="col-4">

<!-- 
                <button pButton type="button" label="Find Account" class="margin-left" (click)="onFindAccount($event)"></button>
-->
                <p-button type="button" label="Find Account" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="onFindAccount($event)" ></p-button>

            </div> 
    
        </div>

        <div  *ngIf="isAccountFound">   
            
            <p-tabs class="wal-tabs" [(value)]="tabIndex">

            <p-tablist>

                <p-tab [value]="'Notifications'">
                <span class="tab-label">
                    <i class="pi pi-pencil" aria-hidden="true"></i>
                    <span class="ml-2">Notifications</span>
                </span>
                </p-tab>

                <p-tab [value]="'Scenarios'">
                <span class="tab-label">
                    <i class="pi pi-tags" aria-hidden="true"></i>
                    <span class="ml-2">Scenarios</span>
                </span>
                </p-tab>

                <p-tab [value]="'Current Values'">
                <span class="tab-label">
                    <i class="pi pi-list" aria-hidden="true"></i>
                    <span class="ml-2">Current Values</span>
                </span>
                </p-tab>

                <p-tab [value]="'Tasks'">
                <span class="tab-label">
                    <i class="pi pi-times" aria-hidden="true"></i>
                    <span class="ml-2">Tasks</span>
                </span>
                </p-tab>

            </p-tablist>  

            <p-tabpanels>

                <p-tabpanel [value]="'Notifications'">

                    <div class="ui-card-light">

                        <form [formGroup]="userform" (ngSubmit)="onSubmitNotification(userform.value)">

                            <div class="field grid pt-5">
                                <div class="col-1"></div>
                                    <label for="passId" class="col-fixed label" style="width: 10em">Pass Template:</label>
                                <div class="col">
                                    <p-select id ="passId" [options]="passTemplates" formControlName="passId" [style]="{'width': '60%'}" 
                                        (onChange)="onChangePassTemplate($event)"
                                        [filter]="false" [editable]="false" pTooltip="Select the pass template" tooltipPosition="top"> 
                                    </p-select>
                                    <p-message severity="error" text="Pass template is required" *ngIf="!userform.get('passId')?.valid&&userform.get('passId')?.dirty"></p-message>                 
                                </div>
                            </div>
            
                            <div class="field grid">
                                <div class="col-1"></div>
                                    <label for="messageTemplateCode" class="col-fixed label" style="width: 10em">Message Template:</label>
                                <div class="col">
                                    <p-select id ="messageTemplateCode" [options]="messageTemplates" formControlName="messageTemplateCode" [style]="{'width': '60%'}" 
                                        (onChange)="onChangeMessageTemplate($event)"
                                        [filter]="false" [editable]="false" pTooltip="Select the message template" tooltipPosition="top"> 
                                    </p-select>
                                    <p-message severity="error" text="Message template is required" *ngIf="!userform.get('messageTemplateCode')?.valid&&userform.get('messageTemplateCode')?.dirty"></p-message>                 
                                </div>
                            </div>
            
                            <div class="field grid" *ngIf="isTemplateShown">
                                <div class="col-1"></div>
                                    <label for="templateHeader" class="col-fixed label" style="width: 10em">Template Header:</label>
                                <div class="col">
                                    <textarea pTextarea id="templateHeader" style="width: 95%;" [rows]="2" [cols]="36" 
                                        pTooltip="The header of the message template" tooltipPosition="top" 
                                        formControlName="templateHeader" > 
                                    </textarea>
                                    <p-message severity="error" text="Template header is required" *ngIf="!userform.get('templateHeader')?.valid&&userform.get('templateHeader')?.dirty"></p-message>                 
                                </div>
                            </div>
            
                            <div class="field grid" *ngIf="isTemplateShown">
                                <div class="col-1"></div>
                                    <label for="templateText" class="col-fixed label" style="width: 10em">Template Text:</label>
                                <div class="col">
                                    <textarea pTextarea id="templateText" style="width: 95%;" [rows]="2" [cols]="36" 
                                        pTooltip="The text of the message template" tooltipPosition="top" 
                                        formControlName="templateText" > 
                                    </textarea>
                                    <p-message severity="error" text="Template text is required" *ngIf="!userform.get('templateText')?.valid&&userform.get('templateText')?.dirty"></p-message>                 
                                </div>
                            </div>
            
                            <div class="col-12">
                                <div  class="col-2" class="row container-fluid"  id="divshow">
                                    <p-button type="submit" label="Send Notification" [disabled]="!userform.valid"
                                        styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left">
                                    </p-button>
    
                                </div> 
                            </div>
    
                        </form>

                    </div>

                </p-tabpanel>

                <p-tabpanel [value]="'Scenarios'">

                    <div class="ui-g ui-card-light">

                        <div class="ui-g btn-group" role="group">
                        
                            <p-button type="button" label="Paid" 
                                styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" 
                                (click)="onPaid($event)">
                            </p-button>
                            <p-button type="button" label="Past Due" 
                                styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" 
                                (click)="onPastDue($event)">
                            </p-button>
                            <p-button type="button" label="Cycle" 
                                styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" 
                                (click)="onCycle($event)">
                            </p-button>
                            <p-button type="button" label="Reset to Current Month" 
                                styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" 
                                (click)="onReset($event)">
                            </p-button>
                        
                        </div>

                    </div>

                </p-tabpanel>

                <p-tabpanel [value]="'Current Values'">

                    <div class="ui-g ui-card-light">

                        <p-table #dtt [columns]="varValuesCols" [value]="varValues" selectionMode="single" 
                            class="wal-table"
                            tableStyleClass="prime-table" sortMode="multiple" [paginator]="true" [rows]="15">
                            <ng-template pTemplate="caption">
                            Variable Values
                            </ng-template>
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    @for (col of columns; track col.field) {
                                        <th [pSortableColumn]="col.field"
                                            [style.display]="col.display"
                                            [style.width]="col.width">
                                            {{ col.header }}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    }
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr [pSelectableRow]="rowData">
                                    <td>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [(ngModel)]="rowData.variableId">
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{rowData.variableId}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [(ngModel)]="rowData.variableName">
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{rowData.variableName}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [(ngModel)]="rowData.dataType">
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{rowData.dataType}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <td pEditableColumn>
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [(ngModel)]="rowData.variableValue"
                                                (keydown)="onInputKeyDown($event)">
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{rowData.variableValue}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                </tr>
                            </ng-template>

                        </p-table> 

                        <div class="col-12">
                            <div  class="col-2" class="row container-fluid"  id="divshow">
                                <p-button type="button" label="Send Data Update" 
                                    styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" [ngStyle]="{'margin':'5px'}"
                                    (click)="onSubmitDataUpdate($event)">
                                </p-button>                                
                            </div> 
                        </div>
                        
                    </div>

                </p-tabpanel>

                <p-tabpanel [value]="'Tasks'">

                    <div class="ui-g ui-card-light">

                        <p-table #dt [columns]="taskCols" [value]="tasks" selectionMode="single" 
                                [(selection)]="selectedTask"  class="wal-table"
                                sortMode="multiple" (onRowSelect)="onRowTaskSelect($event)" [paginator]="true" [rows]="15" >
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    @for (col of columns; track col.field) {
                                        <th [pSortableColumn]="col.field"
                                            [style.display]="col.display"
                                            [style.width]="col.width">
                                            {{ col.header }}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    }
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns">
                                <tr [pSelectableRow]="rowData">
                                    @for (col of columns; track col.field) {
                                        <td>
                                            {{ rowData[col.field] }}
                                        </td>
                                    }                                    
                                </tr>
                            </ng-template>
                        </p-table> 
        
                        <div class="col-12">
                            <div  class="col-2" class="row container-fluid"  id="divshow">
                                <p-button type="button" label="Execute Now" 
                                    styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" [ngStyle]="{'margin':'5px'}"
                                    (click)="triggerEvent()">
                                </p-button>                                
                                
                            </div> 
                        </div>
                    </div>

                </p-tabpanel>

            </p-tabpanels>        

            </p-tabs>

        </div>

        <p-footer>
            <mat-icon class="nav-caption wal-center">view_compact</mat-icon>
        </p-footer>        

    </p-card>

</div>



<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="account-tasks"></p-confirmDialog>